import { bindEvents } from '../../utils/window';
/**
 * @module directives/form/float-label
 */

/**
 * Toggle is-selected class on select inputs
 */
export default function floatLabelDirective() {
  document.querySelectorAll('select').forEach(element => {
    element.addEventListener('change', event => {
      if (element.value != '') { 
        element.classList.add('is-selected') 
      } else { 
        element.classList.remove('is-selected') 
      }
    })
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/float-label.js